require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./คนเก่งพักเป็น.json") })
        }
      }, "path---คนเก่งพักเป็น");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---คนเก่งพักเป็น!./.cache/json/คนเก่งพักเป็น.json
// module id = 599
// module chunks = 231608221292675